import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {InputChipCellRendererParams} from './input-chip-cell-renderer-params.interface';

@Component({
  templateUrl: './input-chip-cell-renderer.component.html'
})
export class InputChipCellRendererComponent implements ICellRendererAngularComp {
  public chips: {id: number; name: string}[];
  public compact: boolean;
  public clickable: boolean;
  private onChipClick: () => void;

  public agInit(params: InputChipCellRendererParams): void {
    this.chips = params.value;
    this.compact = params.compact ?? false;
    this.clickable = params.clickable ?? false;
    this.onChipClick = params.onChipClick;
  }

  public refresh(params: any): boolean {
    return false;
  }

  public chipClick(): void {
    if (this.onChipClick) {
      this.onChipClick();
    }
  }

  public onChipDoubleClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}
